import { __decorate, __extends, __metadata, __values } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
var KkTextField = /** @class */ (function (_super) {
    __extends(KkTextField, _super);
    function KkTextField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KkTextField.prototype, "errors", {
        get: function () {
            var e_1, _a;
            var anyError = false;
            var errors = [];
            if (this.rules) {
                try {
                    for (var _b = __values(this.rules), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var rule = _c.value;
                        var result = rule(this.value);
                        if (result === true) {
                            continue;
                        }
                        anyError = true;
                        if (typeof result === "string") {
                            errors.push(result);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (!anyError) {
                return null;
            }
            return errors;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], KkTextField.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], KkTextField.prototype, "label", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], KkTextField.prototype, "placeholder", void 0);
    __decorate([
        Prop({ default: "text" }),
        __metadata("design:type", String)
    ], KkTextField.prototype, "type", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], KkTextField.prototype, "disabled", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], KkTextField.prototype, "readonly", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], KkTextField.prototype, "rules", void 0);
    KkTextField = __decorate([
        Component
    ], KkTextField);
    return KkTextField;
}(Vue));
export default KkTextField;
